export default __webpack_public_path__ + "media/zurb/img/about/jon/jon-image1-8c235685453bcf74d918e2a0ea225567.png";